<i18n>
{
  "de": {
    "filters": "Filter",
    "resetFilters": "Filter zurücksetzen"
  },
  "en": {
    "filters": "Filters",
    "resetFilters": "Reset filters"
  }
}
</i18n>

<template>
  <div
    v-if="artist && !isMobileView"
    class="filter-shop on-body-background"
  >
    <h5 class="filter-shop__headline mb-10">
      {{ $t('filters') }}
    </h5>

    <filter-shop-content
      :layout="'desktop'"
      @filtersChanged="onFiltersChanged"
    />

    <button
      v-if="hasActiveFilters"
      class="filter-shop__reset-btn"
      @click="resetFilters"
    >
      <i class="icon-times" />
      {{ $t('resetFilters') }}
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FilterShopContent from '~/components/filter-shop-content'

export default {
  name: 'FilterShop',

  components: {
    FilterShopContent
  },

  computed: {
    ...mapState(['artist', 'shopFilter']),

    hasActiveFilters() {
      return this.shopFilter.type !== null ||
        this.shopFilter.sortBy !== 'date' ||
        this.shopFilter.sortOrder !== 'desc'
    }
  },

  methods: {
    ...mapActions(['resetShopFilter']),

    onFiltersChanged() {
      // Filters are automatically applied via Vuex
    },

    resetFilters() {
      this.$root.$emit('resetAllShopFilters')
      this.resetShopFilter()
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-shop {
  padding: 15px 0;

  &__headline {
    font-size: 1.2rem;
    font-weight: 500;
    margin-bottom: 15px;
    padding-bottom: 10px;
  }

  &__reset-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 20px;
    padding: 8px 0;
    background: transparent;
    border: none;
    font-size: 0.85rem;
    font-weight: 500;
    color: var(--body-background-text-color, #333);
    opacity: 0.7;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 0.9rem;
    }
  }
}
</style>
